import { inject } from 'aurelia-framework';
import { NewInstance } from 'aurelia-dependency-injection';
import { ValidationController, validateTrigger, ValidationRules, ValidateBindingBehavior, ValidationRenderer } from 'aurelia-validation';
import { UserService } from '../Advertiser.SharedPortal/services/user-service';
import { LoggerService } from '../Advertiser.SharedPortal/services/logger-service';
import { StatusService } from '../Advertiser.SharedPortal/services/status-service';
import { MultiObserverService } from '../Advertiser.SharedPortal/services/multi-observer-service';
import { BrowserStorageService } from '../Advertiser.SharedPortal/services/browser-storage-service';


var config = require('../../config.js');

@inject(UserService, NewInstance.of(ValidationController), LoggerService, StatusService, MultiObserverService, BrowserStorageService)
export class ForgotPassword {
   constructor(userService, controller, loggerService, status, multiObserver, browserStorage ) {
      this.userService = userService;
      this.controller = controller;
      this.logger = loggerService;
      this.controller.validateTrigger = validateTrigger.manual;
      this.status = status;
      this.multiObserver = multiObserver;
      this.browserStorage = browserStorage;

      this.errorMessage = '';
      this.submitted = false;
      this.emailAddress = '';

      this.myKeypressCallback = this.keypressInput.bind(this);
   }

   activate() {
      let that = this;
      this.configStatus();
      this.multiObserver.observe(this, ['emailAddress'], function () { that.status.dirty(); });
      window.addEventListener('keypress', this.myKeypressCallback, false);
   }

   deactivate() {
      window.removeEventListener('keypress', this.myKeypressCallback);
   }

   keypressInput(e) {
      if (e.key === 'Enter') {
         this.onSubmit();
      }
   }

   configStatus() {
      // statuses:  dontchange, clean, dirty, working, loading, saving, success, error
      this.status.texts = ['', 'Forgot Password', 'Forgot Password', 'Working', '', '', 'Done', 'Error'];
      this.status.classes = ['', 'btn-disabled', 'btn-enabled', 'btn-processing', '', '', 'btn-success', 'btn-error'];
   }

   onSubmit() {
      this.logger.debug('onSubmit() called');
      let that = this;

      let errors = this.controller.validate()
         .then((err) => {

            if (err.valid) {
               this.status.working();
               this.errorMessage = '';
               this.controller.reset();
               let token = this.browserStorage.getItem('AccessToken');

               this.userService.forgotPassword(this.emailAddress)
                  .then(response => {
                     this.logger.debug('forgotPassword returns: ', response);

                     if (response && response[0] !== 'Success') {
                        this.errorMessage = "That email is not associated with a Delty account. Please re-enter or contact an administrator for support.";
                        this.submitted = false;
                        this.status.set(this.status.statuses.error, this.status.statuses.done, config.buttonReset);
                     }
                     else {
                        this.errorMessage = '';
                        this.status.set(this.status.statuses.success, this.status.statuses.clean, config.buttonReset);
                        setTimeout(function () { that.submitted = true; }, 1500);
                     }
                  });
            }
         });
   }
}

ValidationRules
   .ensure(p => p.emailAddress).required()
   .ensure(p => p.emailAddress).email().withMessage( 'Email address is improperly formated (please ensure it is all lowercase)')
   .on(ForgotPassword);